import React from 'react';
import ModuleOperationsPage from './ModuleOperationsPage';

const DepositOperationsPage: React.FC = () => (
  <ModuleOperationsPage
    category="deposit"
    moduleKey="deposit"
    title="Deposit Operations"
    description="On-chain deposit credits to user balances. Deposits carry no platform fee."
  />
);

export default DepositOperationsPage;
